module.exports = __webpack_public_path__ + "static/img/3.2316aa7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/zh/3.png
// module id = sSy9
// module chunks = 0